import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ── Compute effectiveRole (mirrors Login.jsx logic exactly) ──────────────
  const rawRole  = (user.role             || "").toLowerCase().trim();
  const type     = (user.dashboard_type   || localStorage.getItem("type")     || "").toLowerCase().trim();
  const is_admin = Number(user.is_admin   ?? localStorage.getItem("is_admin") ?? 0);

  const effectiveRole = (is_admin === 1 || type === "admin" || rawRole === "manager") ? "admin" : rawRole;

  // ── Guard check uses effectiveRole, not rawRole ──────────────────────────
  if (!allowedRoles.includes(effectiveRole)) {
    if (effectiveRole === "admin" || effectiveRole === "manager") return <Navigate to="/admin-dashboard" replace />;
    if (effectiveRole === "client")  return <Navigate to="/client-dashboard"  replace />;
    if (effectiveRole === "engineer") return <Navigate to="/engineer"         replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;